import { render, staticRenderFns } from "./queue.vue?vue&type=template&id=7bf5a3a9&scoped=true&"
import script from "./queue.vue?vue&type=script&lang=js&"
export * from "./queue.vue?vue&type=script&lang=js&"
import style0 from "./queue.vue?vue&type=style&index=0&id=7bf5a3a9&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7bf5a3a9",
  null
  
)

export default component.exports